import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-text-chunk-displayer',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  template: `
    @if (chunk(); as chunk) {
      @if (chunk.mainEdition.content === '') {
        <!-- To display the empty chunk -->
        <p>&nbsp;</p>
      } @else {
        <div [ngClass]="chunk.style || ''">
          <markdown [data]="chunk.mainEdition.content"></markdown>
        </div>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextChunkDisplayerComponent {
  chunk = input.required<any>();
}
